var _rect, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBank3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 30,
    viewBox: "0 0 47 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 47,
    height: 30,
    rx: 2,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.8761 8.84132H19.956V21.1624H26.8761V8.84132Z",
    fill: "#FF5F00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.3955 15.0018C20.3944 13.8152 20.6657 12.6439 21.1891 11.5766C21.7124 10.5093 22.474 9.57392 23.4161 8.84132C22.2494 7.93272 20.8482 7.36767 19.3728 7.21077C17.8973 7.05386 16.407 7.31142 15.0723 7.95401C13.7376 8.5966 12.6122 9.59831 11.8249 10.8446C11.0376 12.0909 10.6201 13.5315 10.6201 15.0018C10.6201 16.4721 11.0376 17.9128 11.8249 19.1591C12.6122 20.4054 13.7376 21.4071 15.0723 22.0497C16.407 22.6923 17.8973 22.9498 19.3728 22.7929C20.8482 22.636 22.2494 22.071 23.4161 21.1624C22.474 20.4297 21.7124 19.4944 21.1891 18.4271C20.6658 17.3597 20.3944 16.1884 20.3955 15.0018Z",
    fill: "#EB001B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M36.2117 15.0018C36.2117 16.4721 35.7943 17.9127 35.007 19.159C34.2197 20.4053 33.0945 21.407 31.7598 22.0496C30.4251 22.6922 28.9348 22.9498 27.4593 22.7929C25.9839 22.636 24.5828 22.071 23.4161 21.1624C24.3574 20.429 25.1183 19.4935 25.6416 18.4263C26.1648 17.3592 26.4367 16.1883 26.4367 15.0018C26.4367 13.8154 26.1648 12.6445 25.6416 11.5773C25.1183 10.5102 24.3574 9.57466 23.4161 8.84132C24.5828 7.93272 25.9839 7.36767 27.4593 7.21077C28.9348 7.05386 30.4251 7.31143 31.7598 7.95403C33.0945 8.59663 34.2197 9.59833 35.007 10.8446C35.7943 12.0909 36.2117 13.5316 36.2117 15.0018Z",
    fill: "#F79E1B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M35.4571 19.8574V19.6051H35.5598V19.5537H35.2984V19.6051H35.4011V19.8574H35.4571ZM35.9647 19.8574V19.5532H35.8846L35.7924 19.7624L35.7002 19.5532H35.62V19.8574H35.6766V19.628L35.7631 19.8257H35.8217L35.9082 19.6275V19.8574H35.9647Z",
    fill: "#F79E1B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBank3);
export default __webpack_public_path__ + "static/media/bank3.e533100825dfeeb4ec43b916bdf48440.svg";
export { ForwardRef as ReactComponent };